import React from 'react';
import { renderSafeHtml, normalizeToHttpsUrl } from '../utils/safeHtml';
import { ALL_JOBS_URL } from '../config/careerLinks';
import './HiringBanner.css';

const HiringBanner = ({ 
  label = 'We\'re hiring!',
  title = '現在38職種募集中！',
  description = 'デザイナー、マネージャー、エンジニア、セールスなど<br />多種多様な職種を募集しています。<br />募集要項およびエントリーはこちら。',
  buttonText = '募集要項・エントリー',
  buttonHref = ALL_JOBS_URL,
  imageSrc = '/images/homepage/hiring-banner-section/1.jpg',
  imageAlt = 'FLARETECH採用中 - 一緒に働く仲間を募集しています'
}) => {
  return (
    <section className="hiring-banner-section">
      <div className="hiring-banner">
        <div className="hiring-banner-image">
          <img src={imageSrc} alt={imageAlt} loading="lazy" />
        </div>
        <div className="hiring-banner-content">
          <span className="hiring-label">{label}</span>
          <h2 className="hiring-title">{title}</h2>
          <p className="hiring-desc">{renderSafeHtml(description)}</p>
          <a href={normalizeToHttpsUrl(buttonHref)} className="hiring-button">
            {buttonText}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M7 17L17 7M17 7H7M17 7V17"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HiringBanner;
